import { APIFieldAttributes } from '@ardoq/api-types';
import { DropdownItem, DropdownOptionType } from '@ardoq/dropdown-menu';
import { dispatchAction } from '@ardoq/rxbeach';
import { updateViewSettings } from '@ardoq/view-settings';
import { localeCompare, Locale } from '@ardoq/locale';
import { fieldOperations } from '@ardoq/core';
import { VIEW_ID } from './types';

export const getFieldOptionsForRoadmap = (
  workspaceFields: APIFieldAttributes[],
  selectedFieldName: string | undefined,
  locale: Locale
): DropdownItem[] => {
  const filteredFields = workspaceFields.filter(
    field =>
      fieldOperations.isListField(field) && field.componentType.length > 0
  );

  return filteredFields
    .sort((a, b) => localeCompare(a.label, b.label, locale))
    .map(field => ({
      name: field.name,
      label: field.label,
      isActive: selectedFieldName === field.name,
      onClick: () => {
        dispatchAction(
          updateViewSettings({
            viewId: VIEW_ID,
            settings: { selectedFieldName: field.name },
            persistent: true,
          })
        );
      },
      type: DropdownOptionType.OPTION,
    }));
};
